module.exports = __webpack_public_path__ + "static/polio-3e0287d7c8052fcb3cccd72a7b988bf0.png";